import { useRef, useState } from "react";
import { Shell, PageHead } from "./dc";
import { PRIORITY } from "./campaign/data";
import { CohortCard } from "./campaign/CohortCard";
import { CampaignList } from "./campaign/CampaignList";
import { Builder } from "./campaign/Builder";
import { FocusSend } from "./campaign/FocusSend";

export default function CampaignMockup() {
  const [order, setOrder] = useState(PRIORITY.filter((p) => p.k !== "private_play"));
  const [channel, setChannel] = useState("sms");
  const builderRef = useRef(null);
  const focusRef = useRef(null);
  const go = (r) => r.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  return (
    <Shell title="Customer Intel" testid="campaign-mockup">
      <PageHead title="Campaign Builder" sub="Customer Intel · find the right owners, rank them by how much they're worth to you, and text them through Gingr. Sample data only." />
      <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
        <CohortCard />
        <CampaignList onOpen={() => go(focusRef)} onNew={() => go(builderRef)} />
        <div ref={builderRef}><Builder onBuild={(o, ch) => { setOrder(o); setChannel(ch); go(focusRef); }} /></div>
        <div ref={focusRef}><FocusSend key={order.map((p) => p.k).join() + channel} order={order} channel={channel} /></div>
      </div>
    </Shell>
  );
}
